import { Controller } from "@hotwired/stimulus"

// Shows a confirmation modal before performing a POST request (e.g. reallocate).
// Usage: wrap content in <div data-controller="reallocate-confirm">;
// include modal with data-reallocate-confirm-target="overlay";
// triggers use data-action="click->reallocate-confirm#open" and carry
// either href or data-reallocate-url with the POST URL.
// Modal confirm button: data-action="click->reallocate-confirm#confirm".
export default class extends Controller {
  static targets = ["overlay"]

  open(event) {
    event.preventDefault()
    event.stopPropagation()
    if (!this.hasOverlayTarget) return
    // Prefer the explicit data-reallocate-url over href to avoid "#" or other
    // placeholder hrefs being resolved to the current page URL by the browser.
    this.postUrl = event.currentTarget.dataset.reallocateUrl || event.currentTarget.href
    if (!this.postUrl) return
    this.overlayTarget.classList.remove("hidden")
  }

  close(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    if (!this.hasOverlayTarget) return
    this.overlayTarget.classList.add("hidden")
  }

  overlayClick(event) {
    if (event.target === this.overlayTarget) this.close(event)
  }

  stopPropagation(event) {
    if (event) event.stopPropagation()
  }

  confirm(event) {
    if (event) event.preventDefault()
    if (!this.postUrl) return
    const form = document.createElement("form")
    form.method = "post"
    form.action = this.postUrl
    form.setAttribute("data-turbo", "true")
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
    if (csrfToken) {
      const csrfInput = document.createElement("input")
      csrfInput.type = "hidden"
      csrfInput.name = "authenticity_token"
      csrfInput.value = csrfToken
      form.appendChild(csrfInput)
    }
    document.body.appendChild(form)
    form.requestSubmit()
    document.body.removeChild(form)
    this.overlayTarget.classList.add("hidden")
  }
}
